import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { BehaviorSubject, Observable, Subject } from "rxjs";
import { apiRequest, ServiceBase } from "services";

import {
  MultiWaySearchParams,
  OneWaySearchParams,
  RoundTripSearchParams,
} from "@models/flight-search-params";

@Injectable({
  providedIn: "root",
})
export class FlightSearchService extends ServiceBase {
  searchSucess$: Subject<any>;
  SOURCE_AIRPORT: BehaviorSubject<any>;
  DEST_AIRPORT: BehaviorSubject<any>;
  seatAvailableSuccess$: Subject<any>;
  seatAvailableSuccessBeforeBooking$: Subject<any>;
  fareRulesSuccess$: Subject<any>;
  AirportDetails$: Subject<any>;
  AirportCityDetails$: Subject<any>;
  httpClient: HttpClient;
  brandedFareSearchSucess$: Subject<any>;
  brandedFareSearchRoundtripSucess$: Subject<any>;
  brandedFareSearchMultiwaySucess$: Subject<any>;

  constructor(http: HttpClient) {
    super(http);
    this.httpClient = http;
    this.searchSucess$ = new Subject();
    this.SOURCE_AIRPORT = new BehaviorSubject<any>(null);
    this.DEST_AIRPORT = new BehaviorSubject<any>(null);
    this.seatAvailableSuccess$ = new Subject();
    this.seatAvailableSuccessBeforeBooking$ = new Subject();

    this.fareRulesSuccess$ = new Subject<any>();
    this.AirportDetails$ = new Subject<any>();
    this.AirportCityDetails$ = new Subject<any>();
    this.brandedFareSearchSucess$ = new Subject<any>();
    this.brandedFareSearchRoundtripSucess$ = new Subject<any>();
    this.brandedFareSearchMultiwaySucess$ = new Subject<any>();
  }

  brandedFaresSearchRoundtrip(data) {
    this.post({
      url: "flightbook/flight/v1/BrandedFaresSearch",
      data: data,
      onNotify: this.brandedFareSearchRoundtripSucess$,
      handleErrorThroughSubject: true,
      operationKey: "oneway",
    } as apiRequest<OneWaySearchParams>);
    //    this.post<boolean>( {url: 'flights/flight/v1/SearchAmadeusOneWay', data: data,onNotify:  this.searchSucess$,operationKey:'oneway' } as apiRequest<boolean>);
  }

  brandedFaresSearchMultiCity(data) {
    this.post({
      url: "flightbook/flight/v1/BrandedFaresSearch",
      data: data,
      onNotify: this.brandedFareSearchMultiwaySucess$,
      handleErrorThroughSubject: true,
      operationKey: "oneway",
    } as apiRequest<OneWaySearchParams>);
    //    this.post<boolean>( {url: 'flights/flight/v1/SearchAmadeusOneWay', data: data,onNotify:  this.searchSucess$,operationKey:'oneway' } as apiRequest<boolean>);
  }

  brandedFaresSearch(data) {
    this.post({
      url: "flightbook/flight/v1/BrandedFaresSearch",
      data: data,
      onNotify: this.brandedFareSearchSucess$,
      handleErrorThroughSubject: true,
      operationKey: "oneway",
    } as apiRequest<OneWaySearchParams>);
    //    this.post<boolean>( {url: 'flights/flight/v1/SearchAmadeusOneWay', data: data,onNotify:  this.searchSucess$,operationKey:'oneway' } as apiRequest<boolean>);
  }

  onewaysearch(data: OneWaySearchParams) {
    this.post<OneWaySearchParams>({
      url: "flightbook/flight/v1/SearchOneWay",
      data: data,
      onNotify: this.searchSucess$,
      handleErrorThroughSubject: true,

      operationKey: "oneway",
    } as apiRequest<OneWaySearchParams>);
    //    this.post<boolean>( {url: 'flights/flight/v1/SearchAmadeusOneWay', data: data,onNotify:  this.searchSucess$,operationKey:'oneway' } as apiRequest<boolean>);
  }

  oneWayParallelSearch(data: OneWaySearchParams): Observable<any> {
    return this.httpClient.post("flightbook/flight/v1/SearchOneWay", data);
  }

  roundtripsearch(data: RoundTripSearchParams) {
    this.post<RoundTripSearchParams>({
      url: "flightbook/flight/v1/SearchRoundTrip",
      data: data,
      onNotify: this.searchSucess$,
      handleErrorThroughSubject: true,

      operationKey: "roundtrip",
    } as apiRequest<RoundTripSearchParams>);
    //    this.post<boolean>( {url: 'flights/flight/v1/SearchAmadeusRoundTrip', data: data,onNotify:  this.searchSucess$,operationKey:'roundtrip' } as apiRequest<boolean>);
  }

  roundTripParallelSearch(data: RoundTripSearchParams): Observable<any> {
    return this.httpClient.post("flightbook/flight/v1/SearchRoundTrip", data);
  }

  multiwaysearch(data: MultiWaySearchParams) {
    // this.post<boolean>( {url: 'flights/flight/v1/SearchAmadeusMultiWay', data: data,onNotify:  this.searchSucess$,operationKey:'multiway' } as apiRequest<boolean>);
    this.post<boolean>({
      url: "flightbook/flight/v1/SearchMultiWay",
      data: data,
      onNotify: this.searchSucess$,
      handleErrorThroughSubject: true,

      operationKey: "multiway",
    } as apiRequest<boolean>);
  }

  multiWayParallelSearch(data: MultiWaySearchParams): Observable<any> {
    return this.httpClient.post("flightbook/flight/v1/SearchMultiWay", data);
  }

  lookupSourceAirport(inputkeyup: string, iso2: string) {
    this.post<any>({
      url: "flights/airportlookup",
      onNotify: this.SOURCE_AIRPORT,
      data: { location: inputkeyup, iso: iso2 },
    } as apiRequest<any>);
  }

  lookupDestAirport(inputkeyup: string, iso2: string) {
    this.post<any>({
      url: "flights/airportlookup",
      onNotify: this.DEST_AIRPORT,
      data: { location: inputkeyup, iso: iso2 },
    } as apiRequest<any>);
  }

  checkSeatAvailability(data) {
    this.post<boolean>({
      url: "flightbook/flight/v1/CheckAvailability",
      data: data,
      onNotify: this.seatAvailableSuccess$,
      handleErrorThroughSubject: true,

      operationKey: "seatAvailable",
    } as apiRequest<any>);
  }

  checkSeatAvailabilityBeforeBooking(data) {
    this.post<boolean>({
      url: "flightbook/flight/v1/CheckAvailability",
      data: data,
      onNotify: this.seatAvailableSuccessBeforeBooking$,
      handleErrorThroughSubject: true,
      operationKey: "seatAvailableBookingForm",
    } as apiRequest<any>);
  }

  getFareRules(farerulesObj) {
    this.post<boolean>({
      url: "flightbook/flight/v1/GetFareRules",
      data: farerulesObj,
      onNotify: this.fareRulesSuccess$,
    } as apiRequest<any>);
  }

  getAirportsByIata(code) {
    this.post<boolean>({
      url: "Common/Airport/V1/GetAirportDetails",
      data: code,
      onNotify: this.AirportDetails$,
    } as apiRequest<any>);
  }
  getAirportsByCity(code) {
    this.post<boolean>({
      url: "Common/Airport/V1/GetAirportByCity",
      data: code,
      onNotify: this.AirportCityDetails$,
    } as apiRequest<any>);
  }

  convertFlightBaggageSegmentInfor(baggageSegmentInfo) {
    let baggageInfo = {
      ...baggageSegmentInfo,
      carryOnBaggage: baggageSegmentInfo.segmentBaggage.filter(
        (item) => item.baggageType === "Carry-On",
      ),
      checkedInBaggage: baggageSegmentInfo.segmentBaggage.filter(
        (item) => item.baggageType === "Checked Baggage",
      ),
    };

    return baggageInfo;
  }
}
